import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetSweepDetailsByName',
            headers: {},
            args: {},
            urlArgs: {
                name: payload ? payload.name : null,
            },
        });
        return result;
    };
};
